import { Injectable } from '@angular/core';
import { BaseService } from '../../../shared/services/base.service';
import { ConsultationUrl } from '../../../shared/urls/consultation.url';
import { Utility } from '../../../common/utility';

@Injectable()
export class ConfirmationLabTestService {
  constructor(public baseService: BaseService) {
  }

  getLabTestList(consultationId) {
    let url = Utility.stringFormat(ConsultationUrl.GET_PATIENT_LABTEST, [consultationId]);
    return this.baseService.getData(url);
  }

  getPatientSampleInformation(consultationId) {
    let url = Utility.stringFormat(ConsultationUrl.GET_PATIENT_SAMPLE_INFORMATION, [consultationId]);
    return this.baseService.getData(url);
  }

  getAddLabTestList(consultationId) {
    let url = Utility.stringFormat(ConsultationUrl.GET_REMAIN_PATIENT_LABTEST, [consultationId]);
    return this.baseService.getData(url);
  }
  confirmationLabTest(consultationId, data, isMoveNextStep) {
    let url = Utility.stringFormat(ConsultationUrl.CONFIRM_PATIENT_LABTEST, [consultationId]);
    url += '?isMoveNextStep='+ isMoveNextStep;
    return this.baseService.postData(url, data);
  }
}

const addLabTests: Array<any> = [
  {
    'id': 1,
    'name': 'lab 1'
  },
  {
    'id': 2,
    'name': 'lab 2'
  },
  {
    'id': 3,
    'name': 'lab 3'
  },
  {
    'id': 4,
    'name': 'lab 4'
  },
  {
    'id': 5,
    'name': 'lab 5'
  },
  {
    'id': 6,
    'name': 'lab 6'
  },
  {
    'id': 7,
    'name': 'lab 7'
  },
  {
    'id': 8,
    'name': 'lab 8'
  },
  {
    'id': 9,
    'name': 'lab 9'
  }
];

const labTests = [
  {
    id: '1',
    name: 'B12 & Fotole',
    isDisabled: true,
    isChecked: true
  },
  {
    id: '2',
    name: 'Blood Group (BG)',
    isDisabled: false,
    isChecked: false
  }
];


// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/consultation-process/confirmation-lab-tests/confirmation-lab-test.service.ts